import api from 'api/api'
import { toast } from 'react-toastify'

export const GET_STORES = '[STORES] GET STORES'
export const CRUD_STORE = '[STORES] CRUD STORE'
export const GET_STOCK_IN_STORES_BY_PRODUCT_ID = '[STORES] GET STOCK IN STORES BY PRODUCT ID'

export function getStores() {
  const request = api.get(`/almacen`)
  return (dispatch) => {
    request.then((response) => {
      dispatch({ type: GET_STORES, payload: response.data.detalles })
    }).catch((error) => {
      toast.error("Error inesperado, no se pudo obtener los almacenes")
      console.log(GET_STORES, error)
    })
  }
}

export function saveStore(form) {
  const request = api.post(`/almacen/guardar`, form)
  return (dispatch) => {
    dispatch({ type: CRUD_STORE, payload: { loading: true } })
    request.then((response) => {

      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: CRUD_STORE, payload: { loading: false, crud: true } })
      toast.success(response.data.message)
    }).catch((error) => {
      toast.error("Error inesperado, no se pudo guardar el almacen")
      console.log(CRUD_STORE, error)
    }).finally(() => {
      dispatch({ type: CRUD_STORE, payload: { loading: false, crud: false } })
    })
  }
}

export function deleteStore(form) {
  const request = api.post(`/almacen/eliminar`, form)
  return (dispatch) => {
    dispatch({ type: CRUD_STORE, payload: { loading: true } })
    request.then((response) => {

      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: CRUD_STORE, payload: { loading: false, crud: true } })
      toast.success(response.data.message)
    }).catch((error) => {
      toast.error("Error inesperado, no se pudo eliminar el almacen")
      console.log(CRUD_STORE, error)
    }).finally(() => {
      dispatch({ type: CRUD_STORE, payload: { loading: false, crud: false } })
    })
  }
}

export function getStockInStoresByProductId(productId) {
  const request = api.get(`/almacen-existencias-producto?idproducto=${productId}`)
  return (dispatch) => {
    dispatch({ type: GET_STOCK_IN_STORES_BY_PRODUCT_ID, payload: { loading: true } })
    request.then((response) => {

      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: GET_STOCK_IN_STORES_BY_PRODUCT_ID, payload: { loading: false, data: response.data.detalles } })
    }).catch((error) => {
      toast.error("Error inesperado, no se pudo obtener el stock en almacenes")
      console.log(GET_STOCK_IN_STORES_BY_PRODUCT_ID, error)
    }).finally(() => {
      dispatch({ type: GET_STOCK_IN_STORES_BY_PRODUCT_ID, payload: { loading: false } })
    })
  }
}
